import axios from "axios";
import config from "../../../config";

/**
 * POST api/v1/customer-portal/waitlist
 */
export function fetchCustomerPortalWaitlist(token) {
  return axios.post(`${config.API_URL}customer-portal/waitlist`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/waitlist/join
 * Body: {
 *   service_id, preferred_date, staff_id?, services[]?,
 *   preferred_time? (null|HH:mm|morning|lunch|afternoon|evening|month),
 *   preferred_scope? ("month" when preferred_time is "month"),
 *   notify_via?, keep_original_appt?, booking_type?
 * }
 */
export function joinCustomerPortalWaitlist(token, body) {
  return axios.post(`${config.API_URL}customer-portal/waitlist/join`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/waitlist/confirm
 * Body: { waitlist_id }
 */
export function confirmCustomerPortalWaitlist(token, waitlistId) {
  return axios.post(
    `${config.API_URL}customer-portal/waitlist/confirm`,
    { waitlist_id: waitlistId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

/**
 * POST api/v1/customer-portal/waitlist/leave
 * Body: { waitlist_id }
 */
export function leaveCustomerPortalWaitlist(token, waitlistId) {
  return axios.post(
    `${config.API_URL}customer-portal/waitlist/leave`,
    { waitlist_id: waitlistId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

/**
 * POST api/v1/customer-portal/waitlist/offer-context
 * Body: { waitlist_id }
 */
export function fetchWaitlistOfferContext(token, waitlistId) {
  return axios.post(
    `${config.API_URL}customer-portal/waitlist/offer-context`,
    { waitlist_id: waitlistId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

/**
 * POST api/v1/customer-portal/waitlist/conflict-context
 * Body: { preferred_date }
 */
export function fetchWaitlistConflictContext(token, preferredDate, serviceId, excludeAppointmentId) {
  return axios.post(
    `${config.API_URL}customer-portal/waitlist/conflict-context`,
    {
      preferred_date: preferredDate,
      ...(serviceId ? { service_id: serviceId } : {}),
      ...(excludeAppointmentId ? { exclude_appointment_id: excludeAppointmentId } : {}),
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

/**
 * POST api/v1/customer-portal/waitlist/notifications
 */
export function fetchCustomerPortalWaitlistNotifications(token) {
  return axios.post(
    `${config.API_URL}customer-portal/waitlist/notifications`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

/**
 * POST api/v1/customer-portal/waitlist/notifications/seen
 * Body: { notification_id? }
 */
export function markCustomerPortalWaitlistNotificationsSeen(token, notificationId) {
  const body = notificationId ? { notification_id: notificationId } : {};
  return axios.post(
    `${config.API_URL}customer-portal/waitlist/notifications/seen`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}
